import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export default function CTASection({ title = "Ready to begin your Full Circle Journey?", text = "One client. One organized journey. One place to understand what comes next.", primaryLabel = "Start Your Journey", primaryTo = "/start" }) {
  return (
    <section className="bg-[#101315] grain-overlay py-16 lg:py-24" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-semibold text-cream tracking-tight text-balance">{title}</h2>
        <p className="mt-4 text-lg text-cream/70">{text}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-champagne text-espresso hover:bg-champagne-dark hover:text-espresso rounded-full px-8 h-12 text-base font-semibold" data-testid="cta-primary-button">
            <Link to={primaryTo}>{primaryLabel} <ArrowRight className="ml-2 h-4 w-4" /></Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-white/30 text-cream hover:bg-white/10 hover:text-white rounded-full px-8 h-12 text-base" data-testid="cta-secondary-button">
            <Link to="/contact">Book a Consultation</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
